import {ManualSequenceService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _ManualSequenceService = new ManualSequenceService({client});
export {_ManualSequenceService as ManualSequenceService};
